<div class="h-screen w-screen flex py-8 md:p-0 md:items-center justify-center">
  <div
    class="bg-offwhite-100 rounded-xl center w-11/12 h-[50%] md:w-3/4 shadow-[0_8px_30px_rgb(0,0,0,0.12)] flex">

    <div class="w-0 md:w-1/3  ">
      @if (!isBluebird) {
        <div class="flex-col justify-between pb-0 bg-offwhite-500 rounded-xl hidden md:flex h-full"
          >
          <img src="/assets/logo.png" class="p-4 mt-4 center max-h-28 object-scale-down" />
          <div class="h-[50%] self-center">
            @if (!isBluebird) {
              <img src="/assets/tabletuser.png" class="object-bottom object-cover h-full"
                />
            }
          </div>
        </div>
      }
      @if (isBluebird) {
        <div class="flex-col justify-between pb-0 bg-offwhite-500 rounded-xl hidden md:flex "
          >
          <img src="/assets/bluebirdlogo.png" class="p-4 mt-4 center  object-scale-down" />
          <div class="bg-[url('/assets/bluebirdswirlsmall.png')] bg-repeat h-full">
          </div>
        </div>
      }

    </div>

    <div
      class="flex flex-col justify-between h-full items-center w-full md:w-2/3 p-2 md:p-6 pr-2 flex-grow  overflow-y-auto">
      <div class="mt-4">
        <h1 class="text-3xl text-center">Unsubscribed Successfully</h1>
        <p class="mt-2">You will no longer receive emails from us for future feedback campaigns.</p>
      </div>
      <div class="self-end mr-2">
        <strong class="text-green-400 text-sm">Done in error?</strong>
        <p class="text-xs">Please contact us <a href="mailto:care@careaudits.co.uk"
        class="underline">here</a>.</p>
      </div>

    </div>
  </div>
</div>
